export const routesName = {
  index: '/',
  document: 'document',
  client: 'client',
  user: 'user',
  //
  setting: 'setting',
  settingDestination: 'setting/destination',
  settingDestinationMinistry: 'settings/destination/ministry',
  settingDestinationProvince: 'settings/destination/province',
  settingDestinationDepartment: 'settings/destination/department',
  //
  settingPosition: 'setting/position',
  settingPositionAll: 'settings/position/all',
  settingsPositionCategory: 'settings/position/category',
  //
  settingsRole: 'settings/role',
  settingsPermission: 'settings/permission',
  settingsDocumentType: 'settings/doctype',
  //
  notification_list: 'notification-list',
  cache_management: 'settings/cache-management',
  settings_app_version: 'settings/app-version',
  //
  unauthorized: '/unauthorized',
  login: 'login',
};
